import { SortEvent } from '@app/ti-components/dashboard/directives/sortable-list.directive';

export function reorder<T0, T1, TID>(
  items: T0[],
  settings: T1[],
  getItemId: (item: T0) => TID,
  getSettingId: (setting: T1) => TID,
): void {
  if (settings && settings.length) {
    const itemsInOrder = items.sort((item0, item1) => {
      const item0Index = settings.findIndex((setting) => getSettingId(setting) === getItemId(item0));
      const item1Index = settings.findIndex((setting) => getSettingId(setting) === getItemId(item1));

      if (item0Index >= 0 && item1Index >= 0) {
        return item0Index - item1Index;
      }
      if (item0Index >= 0) {
        return -1;
      }
      if (item1Index >= 0) {
        return 1;
      }
      return 0;
    });

    items.splice(0, items.length, ...itemsInOrder);
  }
}

export function reorderBySortEvent<T>(items: T[], event: SortEvent) {
  if (event.currentIndex !== event.newIndex) {
    const movedItems = items.splice(event.currentIndex, 1);
    items.splice(event.newIndex, 0, ...movedItems);
  }
}
